import { Injectable } from '@angular/core';
import { isEmpty } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class ValueConversionService {

  constructor() { }

  /**
   * Converts a string value to a boolean
   */
  public getBoolean(value: string) {
    if (!value) {
      return false;
    }

    if (typeof(value) == 'boolean'){
      return value;
    }

    const x = value.toLowerCase();

    switch (x) {
      case 't':
      case 'true':
      case '1':
      case 'on':
      case 'yes':
        return true;
      default:
        return false;
    }
  }


  /**
   * A function to create a new array with distinct values from an array with duplicate values
   */
  public distinct(array:Array<any>) {
    return Array.from(new Set(array));
  }

  /**
   * Returns a non-nullable boolean.  Undefined returns as false.
   * @param v
   */
  getDefinedBoolean(v?: boolean): boolean {
    if (v == undefined){
      return false;
    }

    return this.getBoolean(<any>v);
  }

  /**
   * Returns a non-nullable number.  Undefined returns as 0.
   * @param v
   */
  getDefinedNumber(v?: number): any {
    if (v == undefined){
      return 0;
    }

    if (v){
      return v;
    }else{
      return 0;
    }
  }

  /**
   * Wrapper for the LoDash isEmpty function (https://lodash.com/docs/4.17.15#isEmpty)
   * @param v
   */
  isEmpty(v?:any){
    return isEmpty(v);
  }

  /**
   * Capitalize the first letter of a word
   * @param v
   */
  capitalizeFirstLetter(v?:string){
    return v.charAt(0).toUpperCase() + v.substring(1);
  }

  /**
   * Tests string to see if it is upper case.
   * @param v
   */
  isUpperCase(v?:string){
    return /^[A-Z]*$/.test(v);
  }

  /**
   * Converts decimal value to a percent.  Optionally, the value can be rounded to an integer.
   * @param value
   * @param roundValue
   */
  toPercent(value: number, roundValue:boolean): number {
    const v = value * 100.0;

    if (!roundValue)
      return v;

    return Math.round(v);
  }
}